export default __webpack_public_path__ + "static/healthcare-iot-solutions-company-peerbits-738d376817534b6feb0d2f0df4cdd6e0.png";